/**
 * Who accepts an agent's output, in words true for every path (proposal P5,
 * owner rulings 2026-10-21). One copy: the settings page's "How it works" line
 * and its "Who reviews it" section both read it.
 *
 *   one at a time     the reviewer who clicks Accept
 *   many at once      the reviewer who clicks (bulk accept, value agents only)
 *   a standing rule   the administrator who set the value's AI to "provides"
 *                     (migration 920: accepted_by and the decision record's
 *                     reviewed_by are the rule's setter)
 */

export const NAMED_ACCEPTANCE = "Nothing is accepted without a person's name on it.";
export const BULK_ACCEPTANCE = 'Accepting many at once records the reviewer who clicks.';
export const RULE_ACCEPTANCE = 'A standing rule on a value records the administrator who set it.';

/** The whole statement for an agent that proposes values. */
export const VALUE_ACCEPTANCE = `${NAMED_ACCEPTANCE} ${BULK_ACCEPTANCE} ${RULE_ACCEPTANCE}`;

/** Where a value's AI setting (and so its standing rule) is changed. */
export const VALUE_AI_SETTINGS_HREF = '/prioritization/settings/attributes';

/**
 * The statement for one agent: the standing-rule sentence only where a standing
 * rule can exist (an agent that proposes values), the many-at-once sentence only
 * where accepting many at once is offered.
 */
export function acceptanceWords(def: { outputs: readonly string[]; bulkAcceptAllowed: boolean }): string {
  const proposesValues = def.outputs.includes('proposal:value');
  return [NAMED_ACCEPTANCE, (def.bulkAcceptAllowed || proposesValues) && BULK_ACCEPTANCE, proposesValues && RULE_ACCEPTANCE]
    .filter(Boolean)
    .join(' ');
}
